var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.99 20.02C8.01391 20.02 3.98 15.9861 3.98 11.01C3.98 6.03391 8.01391 2 12.99 2C17.9661 2 22 6.03391 22 11.01C22 15.9861 17.9661 20.02 12.99 20.02Z",
    fill: "#9D9DAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00995 18.95C2.33995 18.34 3.03995 18 3.97995 18C4.68995 18 5.29995 18.29 5.65995 18.79C6.01995 19.29 6.09995 19.96 5.87995 20.63C5.44995 21.93 4.69995 22.22 4.28995 22.27C4.22995 22.28 4.16995 22.28 4.09995 22.28C3.65995 22.28 2.97995 22.09 2.31995 21.1C1.78995 20.33 1.68995 19.56 2.00995 18.95Z",
    fill: "#9D9DAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNormal);
export default __webpack_public_path__ + "static/media/search-normal.3f3334fb3e642d3bd6988b743fae566e.svg";
export { ForwardRef as ReactComponent };